module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_cocacola_06.81e6477c.jpg";